// extracted by mini-css-extract-plugin
export var explainable = "_jt-a";
export var printerCard = "_jt-1";
export var printerCardConfigured = "_jt-2";
export var printerCardError = "_jt-3";
export var printerCardsContainer = "_jt-0";
export var printerIcon = "_jt-8";
export var printerIconConfigured = "_jt-5";
export var printerIconContainer = "_jt-4";
export var printerIconError = "_jt-6";
export var printerIconUnconfigured = "_jt-7";
export var workstationsTableCard = "_jt-9";